/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_Checkin_To_StartInputs */



/**
* | output |
* | --- |
* | "Check in registered players to start." |
*
* @param {Overview_Checkin_To_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_checkin_to_start = /** @type {((inputs?: Overview_Checkin_To_StartInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Checkin_To_StartInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pointez les joueurs inscrits pour commencer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Haga check-in de jugadores inscritos para comenzar.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Faça check-in dos jogadores inscritos para começar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fai check in dei giocatori iscritti per iniziare.")
	return /** @type {LocalizedString} */ ("Check in registered players to start.")
});